import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotSites from "./components/HotSites";
import Categories from "./components/Categories";
import LatestReleases from "./components/LatestReleases";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import SubmitForm from "./components/SubmitForm";
import Footer from "./components/Footer";

export default function Home() {
  const [query, setQuery] = useState("");
  const [toast, setToast] = useState("");
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const notify = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2200);
  };

  const scrollToHot = () => {
    document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero query={query} onQueryChange={setQuery} onSearch={scrollToHot} />
        <HotSites onNotify={notify} />
        <Categories query={query} onNotify={notify} />
        <LatestReleases />
        <Guide />
        <Faq />
        <SubmitForm />
      </main>
      <Footer />

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 rounded-full bg-foreground-950 px-5 py-3 text-sm text-background-50 shadow-lg">
          {toast}
        </div>
      )}
    </div>
  );
}